module.exports = __webpack_public_path__ + "static/media/image-2.d23702a9.png";